// extracted by mini-css-extract-plugin
export default {"inviteControl":"_1lGQbawM","inviteDropdown":"_2sQ6XuhW","chevronIcon":"_3hr7PXZE","inviteControlAlreadyInvited":"_2Rxx6-YG"};